import { Flex, Box, Text } from "rebass";

import Icon from "../common/Icon";
import Heading from "../common/Heading";
import Trans from "next-translate/Trans";
import { Caregiver } from "../../interfaces";
import { useState } from "react";

interface Props {
  caregiver: Caregiver;
}

const Details = ({ caregiver }: Props) => {
  const [visibleSections, setVisibleSections] = useState({
    personal: false,
    home: false
  });

  const iconMap = {
    personal: {
      caregiverXpAsDogWalker: "walking",
      caregiverXpAcommodatingDogs: "briefcase",
      caregiverProvideCustomerReviews: "references",
      caregiverOwnVehicle: "vehicle",
      caregiverCanAdministerOralMeds: "oral-meds",
      caregiverCanAdministerInjectedMeds: "injected-meds",
      caregiverHasAnimalCertificate: "medal",
      caregiverVolunteerAnimalGroups: "volunteer",
      caregiverHasKidsUnder18: "kid",
      caregiverHasPppLicense: "license"
    },
    home: {
      garden: "flower",
      terrace: "terrace",
      balcony: "balcony"
    }
  };

  Object.keys(iconMap.home).map(key => {
    if (
      !visibleSections.home &&
      caregiver.property &&
      !!caregiver.property[key]
    )
      setVisibleSections({ ...visibleSections, home: true });
  });

  Object.keys(iconMap.personal).map(key => {
    if (!visibleSections.personal && !!caregiver[key])
      setVisibleSections({ ...visibleSections, personal: true });
  });

  return (
    <>
      {caregiver.property && visibleSections.home && (
        <Box mt={4}>
          <Box mb={3}>
            <Heading as="h3" fontSize={2} fontWeight="bold" mb={1}>
              <Trans
                values={{
                  name: caregiver.name
                }}
                i18nKey={"sitterprofile:caregiverHome"}
              />
            </Heading>
            {caregiver.property?.outdoorSize && (
              <Text as="p" color="darkGray">
                <Trans
                  values={{ size: caregiver.property.outdoorSize }}
                  i18nKey={"sitterprofile:outdoorArea"}
                />
              </Text>
            )}
          </Box>
          {Object.keys(iconMap.home).map(key => {
            return caregiver.property[key] ? (
              <Flex key={key} alignItems="flex-start" mb={1}>
                <Box sx={{ basis: "100%" }} fontSize={3}>
                  <Icon name={iconMap.home[key]} color="springGreen" />
                </Box>
                <Box sx={{ basis: "100%" }}>
                  <Text
                    as="span"
                    sx={{
                      marginLeft: 3
                    }}
                  >
                    <Trans i18nKey={`sitterprofile:${key}`} />
                  </Text>
                </Box>
              </Flex>
            ) : null;
          })}
        </Box>
      )}
      {visibleSections.personal && (
        <Box mt={4}>
          <Heading as="h3" fontSize={2} fontWeight="bold" mb={2}>
            <Trans i18nKey="sitterprofile:moreDetails" />
          </Heading>
          {Object.keys(iconMap.personal).map(key => {
            return caregiver[key] ? (
              <Flex key={key} alignItems="flex-start" mb={1}>
                <Box sx={{ basis: "100%" }} fontSize={3}>
                  <Icon name={iconMap.personal[key]} color="springGreen" />
                </Box>
                <Box sx={{ basis: "100%" }}>
                  <Text
                    as="span"
                    sx={{
                      marginLeft: 3
                    }}
                  >
                    <Trans i18nKey={`sitterprofile:${key}`} />
                  </Text>
                </Box>
              </Flex>
            ) : null;
          })}
        </Box>
      )}
    </>
  );
};

export default Details;
